// resultsTab: the results page's tab to open on (the Results page's My
// adjudications view opens each event on its "judged" tab)
export const NavigationHelper = (event, from, navigate, resultsTab) => {
    const urlEventName = event?.name?.split(" ").join("+");
    if (from === "result") {
        const tab = resultsTab ? `&tab=${resultsTab}` : "";
        // Oireachtas results live on their own page (published-snapshot data
        // shape — B4); feis/grade keep the shared /results page.
        if (event?.eventType === "Oireachtas") {
            navigate(`/oireachtas/results/${urlEventName}?id=${event?._id}${tab}`, { state: { event: event, from: from }, })
            return
        }
        navigate(`/results/${urlEventName}?id=${event?._id}${tab}`, { state: { event: event, from: from }, })
        return
    }
    event?.eventType === "Grade Exam" && navigate(`/grade/${urlEventName}?id=${event?._id}`, { state: { event: event, from: from }, });
    event?.eventType === "Feiseanna" && navigate(`/feis/${urlEventName}?id=${event?._id}`, { state: { event: event, from: from }, });
    event?.eventType === "Oireachtas" && navigate(`/oireachtas/event/${urlEventName}?id=${event?._id}`, { state: { event: event, from: from }, });
}
